import React from "react";
import TopHeader from "../Public_Components/Top_Header";
import Slider from "../Public_Components/Slider";
import AboutSmall from "../Public_Components/About_small";
import CustomerReviews from "../Public_Components/customer_review";
import Footer from "../Public_Components/Footer";
import GlobalFootprint from "../Public_Components/Global";
import Partners from "../Public_Components/Partners";
import Customers from "../Public_Components/Customers";

function Home() {
  return (
    <>
     
      <AboutSmall/>
      <CustomerReviews/>
      <GlobalFootprint/>
      {/* <Partners/> */}
      <Customers/>
      
    
    </>
  );
}

export default Home;
